/**
 * Helpers for working with fish tag values.
 */
export class FishTagService {
    /**
     * Splits a fish tag string into its individual tags.
     *
     * Tags are separated by commas, with surrounding whitespace trimmed and
     * empty entries removed.
     *
     * e.g. "12, 34 ,56" → ["12", "34", "56"], "" → [].
     *
     * @param {string|null} fishTag - The raw fish tag value.
     * @returns {string[]} The individual fish tags.
     */
    static splitFishTags(fishTag) {
        return String(fishTag ?? "")
            .split(",")
            .map((tag) => tag.trim())
            .filter(Boolean)
    }
}
